"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { cx } from "../internal/cx.js";
import { IconHelp } from "../internal/icons.js";
import { Popover } from "./Popover.js";
/** A «?» button: the explanation opens on click in a small panel; Esc and a click outside close it. Unlike Hint, nothing is shown until asked. */
export function InfoTip({ label = "Пояснение", children, className }) {
    const [anchor, setAnchor] = useState(null);
    return _jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: cx("jui-tip-btn", className), "aria-label": label, title: label, "aria-expanded": !!anchor, "aria-haspopup": "dialog", onClick: event => setAnchor(anchor ? null : event.currentTarget), children: _jsx(IconHelp, { small: true }) }), _jsx(Popover, { anchor: anchor, onClose: () => setAnchor(null), label: label, minWidth: 200, className: "jui-tip-pop", children: children })] });
}
